import { render, staticRenderFns } from "./SingleSocialPost.vue?vue&type=template&id=bb1a7b92&"
import script from "./SingleSocialPost.vue?vue&type=script&lang=js&"
export * from "./SingleSocialPost.vue?vue&type=script&lang=js&"
import style0 from "./SingleSocialPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkButton: require('/app/components/LinkButton.vue').default,ImageComponent: require('/app/components/ImageComponent.vue').default})
